import { createTheme } from '@mui/material/styles';

const bgcolor = "#2d4a7a";
const bghover = "#102a55";

// const bgcolor = 'palette.primary.main';
// const bghover = 'palette.primary.dark';

const theme = createTheme({
  palette: {
    primary: {
    //   main: '#1976d2',
        main:bgcolor,
    },
    secondary: {
      main: '#dc004e',
        // main:bghover,
    },
  },
  customColors: {
    // bgSynthesyzer: 'lightyellow',
    // bgContent: 'ivory',
    // bgContent:'lightgray',
    bgSynthesizer:'whitesmoke',
    bgContent:'whitesmoke',
    bgcolor:bgcolor,
    bghover:bghover,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Example customization
        },
        contained: {'&.Mui-disabled': {
                        backgroundColor: '#D3D3D3',
                        color: '#A9A9A9',
                        },
                    '&:hover': {
                        backgroundColor: bghover, // Custom hover color
                    },
                    backgroundColor:bgcolor,
                    borderRadius:'16px',
                    },
        },
      },
    },
});

export default theme;
